module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: _vm.classes
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1786c6c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icon/icon.vue
// module id = 672
// module chunks = 85